import { DailySessionResponse } from '@empathybroker/tsclient-stats/dist/models/daily-session/daily-session.response';

import { AnalyticsState, MutationClass, PeriodsData } from '../../../models';

export class SetSessionsDataMutation implements MutationClass {

  public static execute(state: AnalyticsState, payload: { data: Partial<PeriodsData<DailySessionResponse>>; }): void {
    state.data.overall.sessions = Object.assign({}, state.data.overall.sessions, payload.data);
  }

}
